//@author: devin
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { AddressType } from "../../../pojo/AddressI";
import { ContactTooltipResponse } from "../../../services/tooltip.service";
import { S25ItemTooltip } from "./s25.item.tooltip.directive";

@TypeManagerDecorator("s25-contact-tooltip")
@Component({
    selector: "s25-contact-tooltip",
    template: `
        @if (!s25Item.initPopOver() || s25Item.loading()) {
            Loading...
        } @else if (!item()) {
            Could not load contact details
        } @else {
            <div class="boxHeader">
                <div class="boxHeaderName">{{ item().name }}</div>
            </div>
            <div class="boxBody">
                @if (item().title) {
                    <table cellspacing="0" width="100%">
                        <tr>
                            <td>Title:</td>
                            <td>{{ item().title }}</td>
                        </tr>
                    </table>
                }
                @for (row of item().rows; track $index) {
                    <table cellspacing="0" width="100%">
                        @if (row.address) {
                            <tr>
                                <td>Address:</td>
                                <td>
                                    {{ row.address }}
                                    <span class="note">
                                        (
                                        @if (row.addr_type == AddressType.Work) {
                                            Work
                                        } @else if (row.addr_type == AddressType.Home) {
                                            Home
                                        }
                                        )</span
                                    >
                                </td>
                            </tr>
                        }
                        @if (row.phone) {
                            <tr>
                                <td>Phone:</td>
                                <td>
                                    {{ row.phone }}
                                    <span class="note"
                                        >(
                                        @if (row.addr_type == 3) {
                                            <span>Work</span>
                                        } @else if (row.addr_type == 4) {
                                            <span>Home</span>
                                        }
                                        )</span
                                    >
                                </td>
                            </tr>
                        }
                        @if (row.fax) {
                            <tr>
                                <td>Fax:</td>
                                <td>
                                    {{ row.fax }}
                                    <span class="note"
                                        >(
                                        @if (row.addr_type == 3) {
                                            <span>Work</span>
                                        } @else if (row.addr_type == 4) {
                                            <span>Home</span>
                                        }
                                        )</span
                                    >
                                </td>
                            </tr>
                        }
                        @if (row.e_mail) {
                            <tr>
                                <td>Email:</td>
                                <td>
                                    <a href="mailto:{{ row.e_mail }}">{{ row.e_mail }}</a>
                                    <span class="note"
                                        >(
                                        @if (row.addr_type == 3) {
                                            <span>Work</span>
                                        } @else if (row.addr_type == 4) {
                                            <span>Home</span>
                                        }
                                        )</span
                                    >
                                </td>
                            </tr>
                        }
                    </table>
                }
            </div>
        }
    `,
    host: {
        "[class.contactBox]": "loaded()",
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25ContactTooltip extends S25ItemTooltip<ContactTooltipResponse> {
    protected readonly AddressType = AddressType;
}
